import * as Yup from 'yup';

export default Yup.object().shape({
  lineOfBusiness: Yup.object()
    .nullable()
    .required('SCHEMA_ERRORS.CLIENT_DETAIL_FORM.LINE_OF_BUSINESS_REQUIRED'),
});
